import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { Http, Headers } from '@angular/http';
import { config } from '../_models/apiConfig';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class ElasticSearchService {
  database = firebase.database();
  constructor(private http: Http, private afs: AngularFirestore) {
  }
  getProducts(products, callback: (res: any[]) => void) {
    let response: any[] = []
    let counter = 0;
    products.filter(item => {
      let product = item.substring(1);


      this.afs.collection('entities').ref.where('uniqueName', '==', product).get().then(snap => {
        if (!snap.empty)
          snap.docs.map(snap1 => {
            response.push(snap1.data());

          })
        if (++counter == products.length) callback(response);
      })
    });
  }
  searchBy(term: 'SearchTerm' | 'UniqueName' | 'SearchTermAndType', data: any) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.post(config.live + `entity/searchBy${term}`, data, { headers: headers })
      .map(res => res.json()).map(res => res.map(entity => JSON.parse(entity)));

  }

  multipleSearchBy(items) {
    let counter = 0;
    let getItem = (index) => this.searchBy('UniqueName', { uniqueName: items[index] }).toPromise();

    return getItem(counter).then((data: any[]) => {

      return data.length != 0 || counter == items.length ? data : getItem(++counter)
    })
  }
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/elastic-search.service.ts